export { default } from "@features/investments/screens/method-screen";
